<template>
    <div class="transaction">
        <div class="transaction-container">
            <h3 class="title">
                {{$t("header.deposit")}}
            </h3>
            <div class="item">
                <div class="logo">
                    <div class="head">
                        Ticket iPay
                    </div>
                    <div class="items">
                        <img src="/payment/sq_Ipay.svg" alt="">
                    </div>
                </div>
                <div class="info">
                    <div class="head">Комісія, 0%</div>
                    <div class="body">
                        Наразі поповнення рахунку можливе лише в касі залу гральних автоматів <br>
                        Адреси залів:
                        <ul>
                            <li v-for="point of pointList" :key="point.id"> {{point.cityName}}, {{point.address}}</li>
                        </ul>
                    </div>
                    <!-- <button class="button" @click="onModalDialogOpen(ModalDialogs.Deposit)">Поповнити</button> -->
                </div>
            </div>
        </div>
    </div>
    <component v-if="activeDialog !== ModalDialogs.None" :is="activeDialog" @close="onModalDialogClose" @openDialog="onModalDialogOpen"
               @submit="onModalDialogClose"/>
</template>

<script src="./deposit-view-component.ts">
</script>

<style scoped>

</style>
